module.exports = __webpack_public_path__ + "img/logo_ma_pro_bordeaux.2bf7b961.svg";